import { render, staticRenderFns } from "./AdministratorsEditModal.vue?vue&type=template&id=65ac1290&scoped=true"
import script from "./AdministratorsEditModal.vue?vue&type=script&lang=js"
export * from "./AdministratorsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac1290",
  null
  
)

export default component.exports